// extracted by mini-css-extract-plugin
export default {"app_main_layout_content":"list_app_main_layout_content__7tXZ7","list":"list_list__ctJB-"};